import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { groupService } from "../../services/group.service";

export const listGroup = createAsyncThunk(
  "groupManage/listGroup",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await groupService.listGroup();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listGroupIdByUser = createAsyncThunk(
  "groupManage/listGroupIdByUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await groupService.listGroupIdByUser();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listGroupIdByStaff = createAsyncThunk(
  "groupManage/listGroupIdByStaff",
  async (staffId, { rejectWithValue }) => {
    try {
      const response = await groupService.listGroupIdByStaff(staffId);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
